class HistoryManager {
    parameters = {};

    /**
     * @returns {HistoryManager}
     */
    clear = () => {
        this.parameters = [];
        return this;
    }

    /**
     * @returns {HistoryManager}
     */
    current = () => {
        this.parameters = [];

        const items = window.location.search.substr(1).split('&');
        items.forEach((item) => {
            if (item) {
                const splittedItem = item.split('=');
                let name = splittedItem[0];
                const value = decodeURIComponent(splittedItem[1]);

                if (name.indexOf('[]') > -1) {
                    name = name.substr(0, name.length - 2);
                    if (!this.parameters[name]) {
                        this.parameters[name] = [];
                    }

                    this.parameters[name].push(value);
                } else {
                    this.parameters[name] = value;
                }
            }
        });
        return this;
    }

    /**
     * @param name
     * @returns {*}
     */
    getParameter = (name) => {
        if (this.parameters[name] === undefined) {
            return false;
        }
        return this.parameters[name];
    }

    /**
     * @returns {HistoryManager}
     */
    getParameters = () => ({ ...this.parameters });

    /**
     * @returns {Array}
     */
    toArray = () => {
        const result = [];
        Object.keys(this.parameters).forEach((key) => {
            result.push({
                name: key,
                value: this.parameters[key]
            });
        });

        return result;
    }

    /**
     * @param parameters
     * @returns {HistoryManager}
     */
    setFromArray = (parameters) => {
        parameters.forEach((parameter) => {
            this.parameters[parameter.name] = parameter.value;
        });
        return this;
    }

    /**
     * @param parameters
     * @returns {HistoryManager}
     */
    setFromObject = (parameters) => {
        Object.keys(parameters).forEach((key) => {
            this.parameters[key] = parameters[key];
        });
        return this;
    }

    /**
     * @param name
     * @param value
     * @returns {HistoryManager}
     */
    set = (name, value) => {
        this.parameters[name] = value;
        return this;
    }

    /**
     * @param name
     * @returns {HistoryManager}
     */
    remove = (name) => {
        delete this.parameters[name];
        return this;
    }

    /**
     * @param url
     */
    push = (url) => {
        window.history.pushState({}, '', url);
    }

    /**
     * @param data
     * @returns {string}
     */
    getQuery = (data) => {
        const query = [];
        Object.keys(data).forEach((key) => {
            const value = data[key];
            if (Array.isArray(value)) {
                value.forEach((val) => {
                    query.push(`${key}[]=${encodeURIComponent(val)}`);
                });
            } else {
                query.push(`${key}=${encodeURIComponent(value)}`);
            }
        });
        return query.join('&');
    }

    /**
     * @returns {string}
     */
    apply = () => {
        let query = this.getQuery(this.parameters);
        if (query) {
            query = `?${query}`;
        }
        window.history.pushState({}, '', `${window.location.pathname}${query}`);
        return query;
    }
}

const historyManager = new HistoryManager();
window.HistoryManager = historyManager;
export default historyManager;
